import { useField } from 'formik';
import { Select as SelectMantine } from '@mantine/core';

// @ts-expect-error dumb
export const Select = ({ label, data, ...props }) => {
  // @ts-expect-error dumb
  const [field, meta, helpers] = useField(props);

  const { value } = meta;
  const { setValue } = helpers;

  return (
    <SelectMantine
      label={label}
      value={value}
      onChange={(e) => setValue(e)}
      error={meta.touched && meta.error}
      data={data}
      {...props}
    />
  );
};
